<div class="account-settings-container">
  <div *ngIf="isLoaderVisible">
    <app-loader></app-loader>
  </div>

  <form [formGroup]="accountSettingForm">

    <mat-form-field class="half-width">
      <mat-label>{{'accountDetailsMail' | translate}}</mat-label>
      <input disabled matInput [value]="loggedInUser.email">
    </mat-form-field>

    <mat-form-field class="half-width" *ngIf="loggedInUser.role_id === 1">
      <mat-label>{{'accountDetailsUserType' | translate}}</mat-label>
      <input disabled matInput value="{{'userRoleBuyer' | translate}}">
    </mat-form-field>

    <mat-form-field class="half-width" *ngIf="loggedInUser.role_id === 2">
      <mat-label>{{'accountDetailsUserType' | translate}}</mat-label>
      <input disabled matInput value="{{'userRoleArtist' | translate}}">
    </mat-form-field>

    <div *ngIf="loggedInUser.role_id === 2" class="full-width">
      <mat-form-field class="half-width">
        <mat-label>{{'accountDetailsNrOfListedPaintings' | translate}}</mat-label>
        <input disabled matInput [value]="artObjectsNr.toString()">
      </mat-form-field>

      <mat-form-field class="half-width">
        <mat-label>{{'accountDetailsNrOffersReceived' | translate}}</mat-label>
        <input disabled matInput [value]="offersNr.toString()">
      </mat-form-field>
    </div>

    <mat-form-field class="half-width" *ngIf="loggedInUser.role_id === 1">
      <mat-label>{{'accountDetailsNrOffersMade' | translate}}</mat-label>
      <input disabled matInput [value]="offersNr.toString()">
    </mat-form-field>

    <p></p>

    <mat-form-field class="half-width">
      <mat-label>{{'accountDetailsFirstName' | translate}}</mat-label>
      <input matInput [formControl]="firstNameFormControl">
      <mat-icon matPrefix>mode_edit</mat-icon>
      <mat-error *ngIf="firstNameFormControl.hasError('required')">
        {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="half-width">
      <mat-label>{{'accountDetailsLastName' | translate}}</mat-label>
      <input matInput [formControl]="lastNameFormControl">
      <mat-icon matPrefix>mode_edit</mat-icon>
      <mat-error *ngIf="lastNameFormControl.hasError('required')">
        {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="half-width">
      <mat-label>{{'accountDetailsPhone' | translate}}</mat-label>
      <input matInput [formControl]="phoneFormControl">
      <mat-icon matPrefix>mode_edit</mat-icon>
      <mat-error *ngIf="phoneFormControl.hasError('required')">
        {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
      </mat-error>
    </mat-form-field>

    <p></p>

    <mat-form-field class="half-width">
      <mat-label>{{'accountDetailsNewPassword' | translate}}</mat-label>
      <input matInput [type]="hidePass ? 'password' : 'text'" [formControl]="passwordFormControl">
      <button mat-icon-button matSuffix (click)="hidePass = !hidePass" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePass">
        <mat-icon>{{hidePass ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field class="half-width">
      <mat-label>{{'accountDetailsConfirmNewPassword' | translate}}</mat-label>
      <input matInput [type]="hideConfPass ? 'password' : 'text'" [formControl]="confirmPasswordFormControl">
      <button mat-icon-button matSuffix (click)="hideConfPass = !hideConfPass" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfPass">
        <mat-icon>{{hideConfPass ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>

    <div class="error" *ngIf="errorMessage !== ''"><p>{{errorMessage}}</p></div>

    <div class="full-width">
      <button mat-raised-button (click)="saveUserData()" class="simple-button" [disabled]="accountSettingForm.invalid">{{'accountDetailsSaveModifications' | translate}}</button>
      <button mat-raised-button color="warn" (click)="logout()">
        {{'logOut' | translate}}
      </button>
    </div>
  </form>
</div>
